module.exports = __webpack_public_path__ + "assets/img/143.ce8218a0.png";